import React, { useState } from "react";
import "../Visa.css";
import MediumButton from "../../../component/button/MediumButton";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import VisaImg from "../../../assets/kangaroo/AustraliaBanner.jpg";
import { data } from "../data.js";
import { ChevronDown, Download } from "lucide-react";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import Map from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import { Button, Col, Row } from "reactstrap";
import bannerImg from "../../../assets/kangaroo/AustraliaBanner.jpg";
import { motion } from "framer-motion";

const Visa = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const visaData = data;

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div
        className="hero-banner"
        style={{ "--banner-img": `url(${VisaImg})`, overflow: "hidden" }}
      >
        <SectionContainer className="d-flex align-items-center h-100">
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "SERVICES", link: "/services" },
              { title: "VISA & MIGRATION" },
            ]}
          />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className="banner-text-country lh-1">VISA AND MIGRATION</h1>
            <div onClick={toggleModal}>
              <MediumButton
                label="GET SUPPORT NOW"
                career={true}
                fill="transparent"
                textColor="#821790"
                width={250}
                height={80}
                fontSize={24}
              />
            </div>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <pre className="country-paragraph-text">{visaData[0].description}</pre>
        <h1
          className="font-level-8"
          style={{ marginTop: "63px", marginBottom: "38px" }}
        >
          Study and Training Visa
        </h1>
        {visaData[0].studyvisa.map((item, index, arr) => (
          <>
            <hr className="line-visa" />
            <div key={index} className="d-flex align-items-center gap-2">
              <div className={`dropdown-arrow ${isOpen ? "open" : ""}`}>
                <ChevronDown size="2.5rem" />
              </div>

              <pre className="country-paragraph-text m-0 p-0">{item}</pre>
            </div>
            {index === arr.length - 1 && <hr className="line-visa" />}
          </>
        ))}

        <h1
          className="font-level-8"
          style={{ marginTop: "63px", marginBottom: "38px" }}
        >
          Family and Partner Visa
        </h1>
        {visaData[0].familyVisa.map((item, index, arr) => (
          <>
            <hr className="line-visa" />
            <div key={index} className="d-flex align-items-center gap-2">
              <div className={`dropdown-arrow ${isOpen ? "open" : ""}`}>
                <ChevronDown size="2.5rem" />
              </div>

              <pre className="country-paragraph-text m-0 p-0">{item}</pre>
            </div>
            {index === arr.length - 1 && (
              <hr className="line-visa" style={{ marginBottom: "100px" }} />
            )}
          </>
        ))}
      </SectionContainer>
      <SectionContainer mainId="Innerpage">
        <Row style={{ marginTop: "6rem" }}>
          <Col>
            <h1 className="font-heading">
              Reserve Your One-to-One Visa & Migration Session
            </h1>
            <p className="country-paragraph-text mt-3 mb-4">
              Tell us a bit about yourself and choose a convenient date and
              time, our team will be ready to assist you with your visa
              extension, migration pathways, or documentation support
            </p>
          </Col>
        </Row>

        <DynamicInlineForm
          fullName={true}
          emailAddress={true}
          phoneNumber={true}
          studyLevel={true}
          callBackTime={true}
          nearestOffice={true}
          message={true}
          buttondesc="BOOK YOUR SESSION"
        />
      </SectionContainer>
      <SectionContainer>
        <h1
          className="font-level-8"
          style={{ marginTop: "63px", marginBottom: "38px" }}
        >
          Working and Skilled Visa
        </h1>
        {visaData[0].othervisa.map((item, index, arr) => (
          <React.Fragment key={index}>
            <hr className="line-visa" />

            <div className="d-flex align-items-center gap-2">
              <div
                onClick={() => handleToggle(index)}
                style={{
                  display: "inline-block",
                  transition: "transform 0.3s ease, color 0.3s ease",
                  transform:
                    openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                  color: openIndex === index ? "#83168F" : "#ff4d1d",
                  cursor: "pointer",
                }}
              >
                <ChevronDown size="2.5rem" />
              </div>

              <pre
                className={`m-0 p-0 ${
                  openIndex === index
                    ? "dropdown-heading"
                    : "country-paragraph-text"
                }`}
                style={{ overflow: "hidden" }}
              >
                {item}
              </pre>
            </div>

            {/* 👇 THIS WAS MISSING */}
            {openIndex === index && (
              <div
                className="d-flex flex-column"
                style={{ marginLeft: "3.1rem" }}
              >
                <p className="text-black">
                  Whether for study, work, or other purposes, make use of our
                  seamless visa processing & migration services. Australia is a
                  proud education destination and a home to world-class
                  institutions, campuses and academics. A multicultural and
                  diverse study environment attracts students from all over the
                  world. Australia has established an international reputation
                  for excellence in all fields of education. Australia now has
                  around 630,000 international students from over 140 countries
                  around the world. They are enrolled in a wide range of
                  disciplines at every level of education, including short-term
                  English language courses, bachelor and master’s degrees right
                  through to doctoral degrees.{" "}
                </p>
                <h1 className="dropdown-font">Eligibility Requirements</h1>
                <p className="text-black">
                  • Enroll in a CRICOS Registered Course • Demonstrate Financial
                  Capability • Possess English Proficiency • For students under
                  18, display proof of organized welfare arrangements during
                  their stay in Australia • For accompanying family members,
                  demonstrate Financial Capability to live in Australia • Meet
                  Health & Character Requirements • Obtain OSHC a week prior to
                  arriving in Australia
                </p>
                <img src={bannerImg} alt="" className="rounded-5" />
                <p className="text-black">
                  • Enroll in a CRICOS Registered Course • Demonstrate Financial
                  Capability • Possess English Proficiency • For students under
                  18, display proof of organized welfare arrangements during
                  their stay in Australia • For accompanying family members,
                  demonstrate Financial Capability to live in Australia • Meet
                  Health & Character Requirements • Obtain OSHC a week prior to
                  arriving in Australia
                </p>
                <img src={bannerImg} alt="" />

                <div className="d-flex gap-5 my-5">
                  <motion.button
                    className="rounded-full navbar-btn-font px-3"
                    style={{
                      backgroundColor: "white",
                      width: "max-content",
                      height: "45px",
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",
                      borderRadius: "50px",
                      border: "2px solid #FF4D1D",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    whileHover="hover"
                  >
                    {/* Animated background - must be first */}
                    <motion.div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(to right, #83168F, #D40B84)",
                        zIndex: 0,
                      }}
                      initial={{ x: "-100%" }}
                      variants={{
                        hover: { x: 0 },
                      }}
                      transition={{
                        duration: 0.5,
                        ease: "easeInOut",
                      }}
                    />

                    {/* Content container - above background */}
                    <div
                      style={{
                        position: "relative",
                        zIndex: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <motion.div
                        initial={{ color: "#7e1790" }}
                        variants={{
                          hover: {
                            color: "#fff",
                            transition: {
                              duration: 0.5,
                            },
                          },
                        }}
                        style={{ display: "inline-flex", marginRight: "1rem" }}
                      >
                        <Download />
                      </motion.div>

                      <motion.span
                        style={{ color: "#7e1790" }}
                        initial={{ color: "#7e1790" }}
                        variants={{
                          hover: {
                            color: "#fff",
                            transition: {
                              duration: 0.5,
                            },
                          },
                        }}
                      >
                        DOWNLOAD PDF
                      </motion.span>
                    </div>
                  </motion.button>

                  <motion.button
                    className="rounded-full navbar-btn-font px-3"
                    style={{
                      backgroundColor: "white",
                      width: "max-content",
                      height: "45px",
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",
                      borderRadius: "50px",
                      border: "2px solid #FF4D1D",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    whileHover="hover"
                  >
                    {/* Animated background - must be first */}
                    <motion.div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(to right, #83168F, #D40B84)",
                        zIndex: 0,
                      }}
                      initial={{ x: "-100%" }}
                      variants={{
                        hover: { x: 0 },
                      }}
                      transition={{
                        duration: 0.5,
                        ease: "easeInOut",
                      }}
                    />

                    {/* Content container - above background */}
                    <div
                      style={{
                        position: "relative",
                        zIndex: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <motion.div
                        initial={{ color: "#7e1790" }}
                        variants={{
                          hover: {
                            color: "#fff",
                            transition: {
                              duration: 0.5,
                            },
                          },
                        }}
                        style={{ display: "inline-flex", marginRight: "1rem" }}
                      >
                        <Download />
                      </motion.div>

                      <motion.span
                        style={{ color: "#7e1790" }}
                        initial={{ color: "#7e1790" }}
                        variants={{
                          hover: {
                            color: "#fff",
                            transition: {
                              duration: 0.5,
                            },
                          },
                        }}
                      >
                        DOWNLOAD OTHERS
                      </motion.span>
                    </div>
                  </motion.button>
                </div>
              </div>
            )}

            {index === arr.length - 1 && <hr className="line-visa" />}
          </React.Fragment>
        ))}
      </SectionContainer>

      <hr className="line" />
      <SectionContainer>
        <Map />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default Visa;
